import Logo from "../assets/img/logo.png";
import Recommender from "../assets/img/recommender.svg"
import ChatBot from "../assets/img/chatBot.svg"
import { Link } from "react-router-dom";

const SelectType = () =>{

    return(
        <>
          <div className="h-screen flex flex-col justify-center items-center bg-gray-100 hasBackgroud">
             
           
            <div className="bg-white w-[70%] lg:w-[95%] max-w-[500px] rounded-xl p-6 shadow-lg flex flex-col items-start relative">
            <img src={Logo} className="w-[80px] mb-4 mx-auto block" alt="logo" />
                <h2 className="text-[18px] text-[#f4752a] font-IRANYekanExtra mb-2 text-center mx-auto">به دستیار هوشمند بانک سپه خوش آمدید!</h2>
                <h2 className="text-[14px] font-IRANYekanExtra text-[#000] text-center mx-auto"
                >لطفاً یکی از گزینه‌های زیر را برای دریافت پشتیبانی انتخاب کنید : </h2>
        <div className="my-4 flex items-center w-full">
        <button
                    className="flex justify-center bg-[#fff] mx-1 w-full text-[14px] font-IRANYekanBold text-[#f4752a] shadow-dropbox-shadow px-2 py-2 rounded-lg mt-4 hover:bg-[#000]"
                >
                    <Link to={"/chatBot"} className="flex">
                    <img src={ChatBot} alt=""/>
               <span className="mr-2">
               چت با دستیار هوشمند
               </span>
                    </Link>
               
                </button>
                <button
                    className="flex justify-center bg-[#f4752a] mx-1 w-full text-[14px] font-IRANYekanBold text-white px-2 py-2 rounded-lg mt-4 hover:bg-[#000]"
                >
                    <Link to={"/recommender"} className="flex">
                          <img src={Recommender} alt=""/>
                   <span className="mr-2">ارتباط با سیستم توصیه گر</span>
                    </Link>
             
                </button>
        </div>
            </div>
          </div>
        </>
    )
}

export default SelectType;